import React from "react";
import { connect } from "react-redux";
import { Button, Card, CardBody, Col, DropdownItem, Row } from "reactstrap";
import {
  ActionsRow,
  DetailValue,
  FixedDropDownButton,
  HorizontalLoader,
  Icon,
  InfiniteScroll,
  Loader,
  modal,
  utils,
} from "@mc/mc-legacy";
import QSignAdminApi from "../../../api/gen/qsign/QSignAdminApi";
import "./SignConfigurationsList.scss";
import * as findSealConnectorsActions from "../../../actions/findSealConnectorsActions";
import PeceteniForm from "../../forms/PeceteniForm";
import * as SealSourceInfo from "../../../api/SealSourceInfo";
import * as SealLevelInfo from "../../../api/SealLevelInfo";
/**
 * Šablony - výpis / editace.
 */

class PeceteniList extends React.Component {
  componentDidMount() {
    this.fetchData(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props) => {
    props.dispatch(findSealConnectorsActions.fetchSealConnectorsIfNeeded());
  };
  upravData(data) {
    const {
      tsConnectorId,
      razitko,
      levelRazitko,
      sourceRazitko,
      tsUrl,
      tsLogin,
      tsPassword,
      tsCertPath,
      tsCertPassword,
      tsTimeout,
      razitkoConnectorName,
      ...other
    } = data;
    const sealConnector = {
      ...other,
      timestampConnector: razitkoConnectorName
        ? {
            connectorId: tsConnectorId,
            connectorName: razitkoConnectorName,
            level: levelRazitko,
            source: sourceRazitko,
            tsCertPath,
            tsCertPassword,
            tsUrl,
            tsLogin,
            tsPassword,
            tsTimeout,
          }
        : null,
    };
    return sealConnector;
  }
  handleEditConfig = (item) => {
    const { dispatch } = this.props;
    const { timestampConnector, connectorId, ...other } = item;
    let stampData;
    if (timestampConnector) {
      const {
        connectorId,
        tsUrl,
        tsLogin,
        tsPassword,
        tsCertPath,
        tsCertPassword,
        tsTimeout,
        connectorName,
        level,
        source,
      } = timestampConnector;
      stampData = {
        tsConnectorId: connectorId,
        tsUrl,
        tsLogin,
        tsPassword,
        tsCertPath,
        tsCertPassword,
        tsTimeout,
        levelRazitko: level,
        sourceRazitko: source,
        razitkoConnectorName: connectorName,
      };
    } else {
      stampData = {};
    }

    dispatch(
      modal.ModalActions.show(
        PeceteniForm,
        {
          onSubmit: (data) => {
            const tempConnector = this.upravData(data);
            const signConnector = { connectorId, ...tempConnector };
          return QSignAdminApi.updateSealConnector(signConnector);
          },
          onSubmitSuccess: (result,dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(findSealConnectorsActions.invalidate());

          },
          initialValues: {
            ...other,
            razitko: timestampConnector ? true : null,
            ...stampData,
          },
        },
        "Úprava konfigurace",
        {}
      )
    );
  };

  handleDeleteConfig = (item) => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.showConfirm(
        "Potvrzení smazání",
        "Opravdu chcete smazat konfiguraci " + item.connectorName + "?",
        () =>
          QSignAdminApi.deleteSealConnector(item.connectorId).then(() => {
            dispatch(findSealConnectorsActions.invalidate());
          }),
        null,
        "Potvrdit"
      )
    );
  };
  handleNovy = () => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.show(PeceteniForm, {
        onSubmit: (data) => {
          const sealConnector = this.upravData(data);
          return QSignAdminApi.addSealConnector(sealConnector);
        },
        onSubmitSuccess: (result, dispatch) => {
          dispatch(modal.ModalActions.hide());
          dispatch(findSealConnectorsActions.invalidate());
        },
      })
    );
  };
  renderItem = (item, key) => {
    return (
      <Card key={key}>
        <CardBody>
          <ActionsRow actions={this.renderActions(item)}>
            <Row>
              <Col xs={12} md={4}>
                <DetailValue textOverflow label="název">
                  {item.connectorName}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Typ">
                  {SealSourceInfo.getCaption(item.source)}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Úroveň">
                  {SealLevelInfo.getCaption(item.level)}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Pořadí">
                  {item.connectorOrder}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Časové razítko">
                  {item.timestampConnector ? "Ano" : "Ne"}
                </DetailValue>
              </Col>
            </Row>
          </ActionsRow>
        </CardBody>
      </Card>
    );
  };

  renderActions = (item) => {
    return (
      <Col className="item-actions">
        <FixedDropDownButton color="action" noCaret title={<Icon icon="ellipsis-v" className="item-actions-icon" />}>
          <DropdownItem key="1" onClick={() => this.handleEditConfig(item)}>
            Upravit
          </DropdownItem>
          <DropdownItem key="2" onClick={() => this.handleDeleteConfig(item)}>
            Smazat
          </DropdownItem>
        </FixedDropDownButton>
      </Col>
    );
  };

  render() {
    const { PeceteniList } = this.props;

    if (!PeceteniList) {
      return <Loader />;
    }

    return (
      <div>
        <Row className="d-flex mt-5">
          <Col className="ml-1">
            <h2>{"Seznam pečetění"}</h2>
          </Col>
          <Col className="d-flex">
            <Button
              color="primary"
              className="mr-3"
              style={{
                marginLeft: "auto",
              }}
              onClick={this.handleNovy}
            >
              Přidat
            </Button>
          </Col>
        </Row>
        <InfiniteScroll className="config-list" bordered>
          {PeceteniList.isFetching && <HorizontalLoader key={'loader'} hover />}
          {PeceteniList.rows.length > 0
            ? PeceteniList.rows.map((item, key) => {
                return this.renderItem(item, key);
              })
            : !PeceteniList.isFetching && (
                <Row key={'no-defined'} className="justify-content-center">
                  <h4>Není definována žádná pečeť</h4>
                </Row>
              )}
        </InfiniteScroll>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    PeceteniList: utils.storeFromArea(state, findSealConnectorsActions.SEAL_CONNECTOR_LIST),
  };
}

export default connect(mapStateToProps)(PeceteniList);
